<template>
  <div class="top">
    <img :src="require('@/assets/img/svg/logo_top.svg')" class="top__logo" />
    <div class="top__title">
      {{ $t('header.title') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
}
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  align-items: center;
  border-bottom: 6px solid map-get($generic-color-variants, 'engage');
  background-color: $generic-color-bg;
  padding: 0 24px;
  width: 100%;
  height: 100%;

  &__logo {
    height: 32px;
  }

  &__title {
    flex: 1;
    text-align: center;
    font-size: $font-size-icons;
    font-weight: 800;
  }
}
</style>
